import { ConfigRoutes } from '@shared/models/general/utils.interface'

interface AccesosCrm {
    HOME: ConfigRoutes
    DASHBOARD: ConfigRoutes
    TAREAS: ConfigRoutes
    TAREAS_CLIENTE: ConfigRoutes
    MIS_SEGUIMIENTOS: ConfigRoutes
    GESTION_TAREAS: ConfigRoutes
    GESTION_SEGUIMIENTO: ConfigRoutes
    PROYECTOS: ConfigRoutes
    ASISTENCIA: ConfigRoutes
    REPORTES: ConfigRoutes
    CONFIGURACION: ConfigRoutes
}

interface ModuloCrm {
    ID: number
    ACCESOS: AccesosCrm
}

export const CRM_MODULE: ModuloCrm = {
    ID: 9,
    ACCESOS: {
        HOME: {
            TITLE: 'Home',
            ACCESS: 0,
            PATH_MODULE: '',
            DESCRI: 'Home',
            ROUTE: '/atajos'
        },
        DASHBOARD: {
            TITLE: 'Dashboard',
            ACCESS: 6,
            PATH_MODULE: '',
            DESCRI: 'CRM - Dashboard',
            ROUTE: '/dashboard'
        },
        TAREAS: {
            TITLE: 'Tareas asignadas',
            ACCESS: 3,
            PATH_MODULE: '',
            DESCRI: 'CRM - Tareas asignadas',
            ROUTE: '/crm/task'
        },
        TAREAS_CLIENTE: {
            TITLE: 'Tareas por cliente',
            ACCESS: 3,
            PATH_MODULE: '',
            DESCRI: 'CRM - Tareas por cliente',
            ROUTE: '/crm/client-tasks'
        },
        MIS_SEGUIMIENTOS: {
            TITLE: 'Mis seguimientos',
            ACCESS: 3,
            PATH_MODULE: '',
            DESCRI: 'CRM - Mis seguimientos',
            ROUTE: '/crm/my-follow-ups'
        },
        GESTION_TAREAS: {
            TITLE: 'Gestión de tareas',
            ACCESS: 4,
            PATH_MODULE: '',
            DESCRI: 'CRM - Gestión de tareas',
            ROUTE: '/crm/task-management'
        },
        GESTION_SEGUIMIENTO: {
            TITLE: 'Gestión de seguimiento',
            ACCESS: 4,
            PATH_MODULE: '',
            DESCRI: 'CRM - Gestión de seguimiento',
            ROUTE: '/crm/follow-up-management'
        },
        PROYECTOS: {
            TITLE: 'Proyectos',
            ACCESS: 2,
            PATH_MODULE: '',
            DESCRI: 'CRM - Proyectos',
            ROUTE: '/crm/project'
        },
        ASISTENCIA: {
            TITLE: 'Asistencia',
            ACCESS: 1,
            PATH_MODULE: '',
            DESCRI: 'CRM - Asistencia',
            ROUTE: '/crm/attendance'
        },
        REPORTES: {
            TITLE: 'Reportes',
            ACCESS: 5,
            PATH_MODULE: '',
            DESCRI: 'CRM - Reportes',
            ROUTE: '/crm/reports'
        },
        CONFIGURACION: {
            TITLE: 'Configuración',
            ACCESS: 7,
            PATH_MODULE: '',
            DESCRI: 'CRM - Configuración',
            ROUTE: '/crm/configuration'
        },
    }
}

export interface CrmPage {
    DESCRI: string
    ROUTE: string
    ACCESS: number
}

export interface CrmSection {
    LABEL: string
    PAGES: CrmPage[]
}

export const CRM_SECTIONS_LIST: CrmSection[] = [
    {
        LABEL: 'General',
        PAGES: [
            { DESCRI: 'Home', ROUTE: '/atajos', ACCESS: CRM_MODULE.ACCESOS.HOME.ACCESS },
            { DESCRI: 'Dashboard', ROUTE: '/dashboard', ACCESS: CRM_MODULE.ACCESOS.DASHBOARD.ACCESS },
        ]
    },
    {
        LABEL: 'Tareas',
        PAGES: [
            { DESCRI: 'Tareas asignadas', ROUTE: '/crm/task', ACCESS: CRM_MODULE.ACCESOS.TAREAS.ACCESS },
            { DESCRI: 'Tareas por cliente', ROUTE: '/crm/client-tasks', ACCESS: CRM_MODULE.ACCESOS.TAREAS_CLIENTE.ACCESS },
            { DESCRI: 'Mis seguimientos', ROUTE: '/crm/my-follow-ups', ACCESS: CRM_MODULE.ACCESOS.MIS_SEGUIMIENTOS.ACCESS },
            { DESCRI: 'Gestión de tareas', ROUTE: '/crm/task-management', ACCESS: CRM_MODULE.ACCESOS.GESTION_TAREAS.ACCESS },
            { DESCRI: 'Gestión de seguimiento', ROUTE: '/crm/follow-up-management', ACCESS: CRM_MODULE.ACCESOS.GESTION_SEGUIMIENTO.ACCESS },
        ]
    },
    {
        LABEL: 'Proyectos',
        PAGES: [
            { DESCRI: 'Proyectos', ROUTE: '/crm/project', ACCESS: CRM_MODULE.ACCESOS.PROYECTOS.ACCESS },
        ]
    },
    {
        LABEL: 'Asistencia',
        PAGES: [
            { DESCRI: 'Asistencia', ROUTE: '/crm/attendance', ACCESS: CRM_MODULE.ACCESOS.ASISTENCIA.ACCESS },
        ]
    },
    {
        LABEL: 'Reportes',
        PAGES: [
            { DESCRI: 'Reportes', ROUTE: '/crm/reports', ACCESS: CRM_MODULE.ACCESOS.REPORTES.ACCESS },
        ]
    },
    {
        LABEL: 'Configuración',
        PAGES: [
            { DESCRI: 'Configuración', ROUTE: '/crm/configuration', ACCESS: CRM_MODULE.ACCESOS.CONFIGURACION.ACCESS },
        ]
    },
]
